import forEachEls from "../foreach-els";

import parseElement from "./parse-element";

export default function(el) {
  forEachEls(this.getElements(el), parseElement, this)
}
